import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { green } from "@mui/material/colors";
import { connect } from "react-redux";
import NpsRating from "../../NPS";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const SangerSequencingReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    const [userInput, setUserInput] = useState("");

    const handleInputChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setUserInput(e.target.value);
    };

    //Report Data
    const [SangerSequencing, setSangerSequencing] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setSangerSequencing(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])

    //Booking Data
    const [SangerSequencingReport, setSangerSequencingReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setSangerSequencingReport(data);
    }, [reportListParameter])

    useEffect(() => {
        setSample_Collected(SangerSequencingReport[0]?.collection_date);
        setSample_Receivedtime(SangerSequencingReport[0]?.pickup_time);
        setdesignation(SangerSequencingReport[0]?.designation);
        setGender(SangerSequencingReport[0]?.customer_gender);
        setSample_Received(SangerSequencingReport[0]?.pickup_date);
        setName(SangerSequencingReport[0]?.customer_name);
        setAge(SangerSequencingReport[0]?.customer_age);
        setDob(SangerSequencingReport[0]?.dob);
        setUuid(SangerSequencingReport[0]?.uuid);
    }, [SangerSequencingReport]);


    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(SangerSequencingReport[0]?.customer_age);
        }
    }, [dob]);




    //Lmp
    const [lmp, setLmp] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.lmp_date &&
            reportListParameter?.lmp_date.length > 0
        ) {
            reportListParameter?.lmp_date?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLmp(data);
    }, [reportListParameter]);

    const updateLmp = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...lmp]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLmp(storeData);
    }

    // Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }


    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    // Hospital Id
    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }

    //CLINICAL HISTORY
    const [SangerSequencingHistory, setSangerSequencingHistory] = useState<any>([]);
    useEffect(() => {
        const SangerSequencingclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance
            &&
            reportListParameter?.clinical_significance
                ?.length > 0
        ) {
            reportListParameter?.clinical_significance
                ?.map((list: any) => {
                    SangerSequencingclincdata?.push({ ...list });
                });
        }
        setSangerSequencingHistory(SangerSequencingclincdata);
    }, [reportListParameter]);

    const updateHistory = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...SangerSequencingHistory]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingHistory(storeData);
    }



    //CLINICAL INDICATIONS 
    const [SangerSequencingClinData, setSangerSequencingClinData] = useState<any>([]);
    useEffect(() => {
        const SangerSequencingclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                SangerSequencingclincdata?.push({ ...list });
            });
        }
        setSangerSequencingClinData(SangerSequencingclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...SangerSequencingClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingClinData(storeData);
    }

    // RESULTS
    let Data = [
        {
            id: 1,
            gene: "NA",
            index1: " C.",
            index2: " P.",
            status: "N/A",
            inharitance: "N/A",

        },
        {
            id: 2,
            name: "NA",
            gene: "NA",
            index1: " C.",
            index2: " P.",
            status: "N/A",
            inharitance: "N/A",
        },
        {
            id: 3,
            gene: "NA",
            index1: " C.",
            index2: " P.",
            status: "N/A",
            inharitance: "N/A",
        },
    ];
    let prevGene = '';
    const [VarientResult, setVarientResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setVarientResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "gene":
                newItem.gene = value;
                break;
            case "index1":
                newItem.index1 = value;
                break;
            case "index2":
                newItem.index2 = value;
                break;
            case "status":
                newItem.status = value;
                break;
            case "inharitance":
                newItem.inharitance = value;
                break;
            default:
                break;



        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    // Interpretation
    const [SangerSequencingInterpretation, setSangerSequencingInterpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.interpretation
            &&
            reportListParameter?.interpretation
                .length > 0
        ) {
            reportListParameter?.interpretation
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setSangerSequencingInterpretation(data);
    }, [reportListParameter]);

    const updateInterpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingInterpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingInterpretation(storeData);
    }


    //RECOMMANDATION
    const [SangerSequencingRecommandation, setSangerSequencingRecommandation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.recommendations &&
            reportListParameter?.recommendations.length > 0
        ) {
            reportListParameter?.recommendations?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setSangerSequencingRecommandation(data);
    }, [reportListParameter]);

    const updateRecommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingRecommandation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingRecommandation(storeData);
    }


    //upload image 0

    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);
    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };



    //graph 0
    const [SangerSequencinggraph, setSangerSequencinggraph] = useState<any>([]);
    useEffect(() => {
        const bcrgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image
            &&
            reportListParameter?.graph_image
                ?.length > 0
        ) {
            reportListParameter?.graph_image
                ?.map((list: any) => {
                    bcrgraph?.push({ ...list });
                });
        }
        setSangerSequencinggraph(bcrgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencinggraph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencinggraph(storeData);
    }

    //status 0
    const [SangerSequencingStatus0, setSangerSequencingStatus0] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status1
            &&
            reportListParameter?.status1
                .length > 0
        ) {
            reportListParameter?.status1
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setSangerSequencingStatus0(data);
    }, [reportListParameter]);

    const updateStatus0 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingStatus0]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingStatus0(storeData);
    }


    //upload image  1
    const [filePreviews1, setFilePreviews1] = useState<Array<string[]>>([]);

    const handleFileUpload1 = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData1(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews1 = [...filePreviews1];
            if (!updatedFilePreviews1[index]) {
                updatedFilePreviews1[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews1[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews1((prevPreviews) => {
                    const updatedPreviews1 = [...prevPreviews];
                    updatedPreviews1[index] = [base64Preview];
                    return updatedPreviews1;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };

    //graph 1
    const [sangergraph1, setGraph1] = useState<any>([]);
    useEffect(() => {
        const bcrgraph1: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image1 &&
            reportListParameter?.graph_image1?.length > 0
        ) {
            reportListParameter?.graph_image1?.map((list: any) => {
                bcrgraph1?.push({ ...list });
            });
        }
        setGraph1(bcrgraph1);
    }, [reportListParameter]);

    const updateGraphData1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sangergraph1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph1(storeData);
    }

    //status 1
    const [SangerSequencingStatus1, setSangerSequencingStatus1] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status2

            &&
            reportListParameter?.status2

                .length > 0
        ) {
            reportListParameter?.status2

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setSangerSequencingStatus1(data);
    }, [reportListParameter]);

    const updateStatus1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingStatus1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingStatus1(storeData);
    }

    //upload image 2
    const [filePreviews2, setFilePreviews2] = useState<Array<string[]>>([]);

    const handleFileUpload2 = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData2(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews2 = [...filePreviews2];
            if (!updatedFilePreviews2[index]) {
                updatedFilePreviews2[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews2[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews2((prevPreviews) => {
                    const updatedPreviews2 = [...prevPreviews];
                    updatedPreviews2[index] = [base64Preview];
                    return updatedPreviews2;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };

    //graph 2
    const [sangergraph2, setGraph2] = useState<any>([]);
    useEffect(() => {
        const bcrgraph2: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image2 &&
            reportListParameter?.graph_image2?.length > 0
        ) {
            reportListParameter?.graph_image2?.map((list: any) => {
                bcrgraph2?.push({ ...list });
            });
        }
        setGraph2(bcrgraph2);
    }, [reportListParameter]);

    const updateGraphData2 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sangergraph2]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph2(storeData);
    }

    //status 2
    const [SangerSequencingStatus2, setSangerSequencingStatus2] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status3
            &&
            reportListParameter?.status3
                .length > 0
        ) {
            reportListParameter?.status3
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setSangerSequencingStatus2(data);
    }, [reportListParameter]);

    const updateStatus2 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingStatus2]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingStatus2(storeData);
    }


    //doctor list
    const [SangerSequencingdoctorList, setSangerSequencingdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setSangerSequencingdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...SangerSequencingdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setSangerSequencingdoctorList(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }
    //Submit Data
    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (lmp.length > 0) {
            lmp?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingReport.length > 0) {
            SangerSequencingReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencing.length > 0) {
            SangerSequencing?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingHistory.length > 0) {
            SangerSequencingHistory?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (SangerSequencingClinData.length > 0) {
            SangerSequencingClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingRecommandation.length > 0) {
            SangerSequencingRecommandation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (SangerSequencingInterpretation.length > 0) {
            SangerSequencingInterpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (SangerSequencinggraph.length > 0) {
            SangerSequencinggraph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sangergraph1.length > 0) {
            sangergraph1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sangergraph2.length > 0) {
            sangergraph2?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (SangerSequencingdoctorList.length > 0) {
            SangerSequencingdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingStatus0.length > 0) {
            SangerSequencingStatus0?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingStatus1.length > 0) {
            SangerSequencingStatus1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (SangerSequencingStatus2.length > 0) {
            SangerSequencingStatus2?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (VarientResult.length > 0) {
            VarientResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${SangerSequencing[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="SangerSequencing-page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="SangerSequencing-main-content3">.</div>
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#400354" }}>SANGER </span><span style={{ fontWeight: "bold", color: "#750b1e" }}>SEQUENCING</span>
                    </div>
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "13px", }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="SangerSequencing-marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {SangerSequencingReport[0]?.pk
                                                ? SangerSequencingReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Age
                                        </Grid>
                                        {dob === "" || dob === null ? (
                                            <Grid item xs={8.5}>
                                                :
                                                {(SangerSequencingReport[0]?.customer_name.includes('Af') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('AF') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('CVS') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Cvs') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('POC') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Poc') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('FETUS') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Fetus') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    : <> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                                }
                                            </Grid>
                                        ) : (
                                            <Grid item xs={8.5}>
                                                :
                                                {(SangerSequencingReport[0]?.customer_name.includes('Af') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('AF') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('CVS') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Cvs') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('POC') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Poc') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('FETUS') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('Fetus') ||
                                                    SangerSequencingReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    :
                                                    <span> {age} Y</span>

                                                }
                                            </Grid>
                                        )
                                        }
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            GA/LMP Date
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :{lmp?.map((list: any, index: number) => {
                                                return (
                                                    // <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)} />
                                                    <input
                                                        style={{
                                                            border: "none",
                                                            width: "97%",
                                                            background: "none",
                                                            fontWeight: "bold",
                                                        }}
                                                        value={list?.parameter_value}
                                                        onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)}
                                                    />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {(SangerSequencingReport[0]?.customer_name.includes('Af') ||
                                                SangerSequencingReport[0]?.customer_name.includes('AF') ||
                                                SangerSequencingReport[0]?.customer_name.includes('CVS') ||
                                                SangerSequencingReport[0]?.customer_name.includes('Cvs') ||
                                                SangerSequencingReport[0]?.customer_name.includes('POC') ||
                                                SangerSequencingReport[0]?.customer_name.includes('Poc') ||
                                                SangerSequencingReport[0]?.customer_name.includes('FETUS') ||
                                                SangerSequencingReport[0]?.customer_name.includes('Fetus') ||
                                                SangerSequencingReport[0]?.customer_name.includes('F/O'))
                                                ? 'NA'
                                                : <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {SangerSequencingReport[0]?.center?.name && SangerSequencingReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>

                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="tissue"> FFPE TISSUE BLOCK</option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.5}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.6}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "53%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "41%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Paper>
                    <div style={{ width: "95%", marginLeft: "24px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{SangerSequencingReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <div className="SangerSequencing-br">.</div>

                    <div className="SangerSequencing-clinical__indicatio" >
                        <span className="SangerSequencing-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL HISTORY</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {SangerSequencingHistory?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={5}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateHistory(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    {/* <div className="SangerSequencing-br">.</div> */}
                    {/* clinical indication  */}
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span className="SangerSequencing-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {SangerSequencingClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={5}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    {/* <div className="SangerSequencing-br">.</div> */}
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span className="SangerSequencing-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>RESULT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    {/* <div style={{ width: "93%", border: "1px solid gray", marginLeft: "40px", height: "55px", }}> */}
                    <div style={{ marginLeft: "40px", display: "flex", background: "#e8eded", color: "  rgb(5, 57, 110)", fontWeight: "bolder", fontSize: "18px", height: "55px", textAlign: "center", border: "1px solid gray", width: "93%" }}>
                        <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px", }}>Patient Name</p>
                        <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Gene</p>
                        <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Variant reported in the index patient</p>
                        <p style={{ width: "15%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Variant Status</p>
                        <p style={{ width: "15%", textAlign: "center", height: "55px" }}>Inheritance</p>

                    </div>
                    {/* </div> */}
                    <div>
                        <div className="contain" style={{ border: "1px solid gray", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    fontSize: "14px",
                                                    height: "65px",
                                                }}
                                            >
                                                <div style={{ width: "25%", borderRight: "1px solid gray", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", textAlign: "center", marginTop: "20px" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                                <div
                                                    style={{ width: "25%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "20px", textAlign: "center" }}
                                                            value={list?.gene}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "gene", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "25%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "left", borderBottom: "1px solid gray" }}
                                                            value={list?.index1}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "index1", e.target.value, list)

                                                            }
                                                        />
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "left" }}
                                                            value={list?.index2}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "index2", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "15%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "20px", textAlign: "center" }}
                                                            value={list?.status}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "status", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "15%", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "20px", textAlign: "center" }}
                                                            value={list?.inharitance}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "inharitance", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                            </div>

                                        </>
                                    );
                                })}
                        </div>
                    </div>

                    <div className="SangerSequencing-main-content5">.</div>

                    {/* doctor sign */}
                    <div
                        style={{
                            width: '89%',
                            display: 'flex',
                            padding: 0,
                            margin: 0,
                            justifyContent: 'space-around',
                            marginTop: '30px',
                        }}
                    >
                        {SangerSequencingdoctorList &&
                            SangerSequencingdoctorList?.length > 0 &&
                            SangerSequencingdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                        {SangerSequencingdoctorList &&
                            SangerSequencingdoctorList?.length > 0 &&
                            SangerSequencingdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                            rows={4}
                                            cols={140}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                        />
                                    </>
                                );
                            })}
                    </div>


                    <div className="SangerSequencing-main-content2">.</div>
                    <div className="SangerSequencing-main-content4">.</div>
                    {/* <div className="SangerSequencing-br">.</div> */}

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{SangerSequencingReport[0]?.designation}&nbsp;{SangerSequencingReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{SangerSequencingReport[0]?.pk}
                    </div>

                    <div className="SangerSequencing-br">.</div>
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            INTERPRETATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {SangerSequencingInterpretation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={7}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateInterpretation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="SangerSequencing-br">.</div>
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            RECOMMENDATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {SangerSequencingRecommandation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={4}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateRecommendation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="SangerSequencing-br">.</div>
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            TECHNOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto", }}>
                        <p>
                            Targeted sequencing and mutation analysis was performed by Polymerase Chain Reaction (PCR) followed by automated DNA sequencing
                            of the amplicon using BigDye ABI Genetic Analyzer 3500XL platform. The raw data obtained is subsequently analyzed for the nucleotide
                            variants.
                        </p>
                    </div>

                    <div className="SangerSequencing-br">.</div>
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            DISCLAIMER
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto", }}>
                        <p>
                            This test is designed to detect mutations in the above-mentioned regions only. Sequences surrounding the regions of interest
                            are analysed but not reported.In rare cases because of allele dropout, heterozygosity may be reported as homozygosity.This
                            assay is unable to differentiate between cis and trans mutations. Though oligos are designed specifically to parent gene using
                            bioinformatics tool, Interference of pseudogene sequence cannot be ruled out completely. Any change in primer binding site
                            can result and interfere with the results and allele dropout cannot be ruled out using this experiment.
                        </p>
                    </div>
                    <div className="SangerSequencing-main-content4">.</div>
                    <div className="sign">.</div>

                    {/* doctor sign */}
                    <div
                        style={{
                            width: '89%',
                            display: 'flex',
                            padding: 0,
                            margin: 0,
                            justifyContent: 'space-around',
                            marginTop: '30px',
                        }}
                    >
                        {SangerSequencingdoctorList &&
                            SangerSequencingdoctorList?.length > 0 &&
                            SangerSequencingdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                        {SangerSequencingdoctorList &&
                            SangerSequencingdoctorList?.length > 0 &&
                            SangerSequencingdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                            rows={4}
                                            cols={140}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                        />
                                    </>
                                );
                            })}
                    </div>

                    <div className="SangerSequencing-main-content2">.</div>
                    <div className="SangerSequencing-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{SangerSequencingReport[0]?.designation}&nbsp;{SangerSequencingReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{SangerSequencingReport[0]?.pk}
                    </div>
                    <div className="SangerSequencing-br">.</div>

                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            ANNEXURE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div>
                        <>
                            {SangerSequencinggraph.map((list: any, index: number) => {

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '95%',
                                            padding: 15,
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            marginLeft: '35px',
                                        }}
                                    >
                                        {/* Display base64-encoded image */}
                                        {thirdP === 'edit' &&
                                            list.parameter_type === 'free_text' &&
                                            list.parameter_name === 'graph_image8' &&
                                            list.parameter_value &&
                                            list.parameter_value.startsWith('data:image/') && (
                                                <div>
                                                    <img
                                                        src={list.parameter_value}
                                                        alt={`Image ${index}`}
                                                        style={{ width: '100%', height: 'auto', maxHeight: '200px' }}
                                                    />
                                                </div>
                                            )}
                                        {/* Display file previews */}
                                        {index === 0 &&
                                            filePreviews[index] &&
                                            filePreviews[index].map((preview: string, previewIndex: number) => (
                                                <img
                                                    key={previewIndex}
                                                    src={preview}
                                                    alt={`File Preview ${previewIndex + 1}`}
                                                    style={{ width: '100%', height: 'auto', maxHeight: '200px' }}
                                                />
                                            ))}
                                        {thirdP !== 'edit' && (
                                            <input
                                                type="file"
                                                onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    </div>
                    <div>
                        {SangerSequencingStatus0.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={2}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateStatus0(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>

                    {/* Graph2  */}
                    <div>
                        <>

                            {sangergraph1.map((list: any, index: number) => {
                                const isImageSelected = thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image10' && list.parameter_value && list.parameter_value.startsWith('data:image/');
                                const isFileSelected = index === 0 && filePreviews1[index];
                                const marginTop = isImageSelected || isFileSelected ? "2px" : "260px";

                                if (isImageSelected) {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            <img
                                                src={list.parameter_value}
                                                alt={`Image ${index}`}
                                                style={{ width: '100%', height: 'auto', maxHeight: "200px" }}
                                            />
                                            <div style={{ marginTop: "10px", fontSize: "17px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={2}
                                                        cols={112}
                                                        value={SangerSequencingStatus1[index]?.parameter_value}
                                                        onChange={(e) => updateStatus1(SangerSequencingStatus1[index]?.id, e.target.value, index, "free_text", SangerSequencingStatus1[index])}
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>
                                    );
                                }
                                else if (isFileSelected) {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            {filePreviews1[index].map((preview: string, previewIndex: number) => (
                                                <img
                                                    key={previewIndex}
                                                    src={preview}
                                                    alt={`File Preview ${previewIndex + 1}`}
                                                    style={{ width: "100%", height: "auto", maxHeight: "200px" }}
                                                />
                                            ))}
                                            <div style={{ marginTop: "10px", fontSize: "17px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none", }}
                                                        rows={2}
                                                        cols={112}
                                                        value={SangerSequencingStatus1[index]?.parameter_value}
                                                        onChange={(e) => updateStatus1(SangerSequencingStatus1[index]?.id, e.target.value, index, "free_text", SangerSequencingStatus1[index])}
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload1(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                }
                                else {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px", marginTop: marginTop }}
                                        >
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload1(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                }
                            })}


                        </>
                    </div>

                    {/* image 3 */}
                    <div>
                        <>
                            {sangergraph2.map((list: any, index: number) => {
                                const isImageSelected = thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image11' && list.parameter_value && list.parameter_value.startsWith('data:image/');
                                const isFileSelected = index === 0 && filePreviews2[index];
                                const marginTop = isImageSelected || isFileSelected ? "2px" : "260px";

                                if (isImageSelected) {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px", marginTop: marginTop }}
                                        >
                                            <img
                                                src={list.parameter_value}
                                                alt={`Image ${index}`}
                                                style={{ width: '100%', height: 'auto', maxHeight: "200px" }}
                                            />
                                            <div style={{ marginTop: "10px", fontSize: "17px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={2}
                                                        cols={112}
                                                        value={SangerSequencingStatus2[index]?.parameter_value}
                                                        onChange={(e) => updateStatus2(SangerSequencingStatus2[index]?.id, e.target.value, index, "free_text", SangerSequencingStatus2[index])}
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>
                                    );
                                }
                                else if (isFileSelected) {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px", marginTop: marginTop }}
                                        >
                                            {filePreviews2[index].map((preview: string, previewIndex: number) => (
                                                <img
                                                    key={previewIndex}
                                                    src={preview}
                                                    alt={`File Preview ${previewIndex + 1}`}
                                                    style={{ width: "100%", height: "auto", maxHeight: "200px" }}
                                                />
                                            ))}
                                            <div style={{ marginTop: "10px", fontSize: "17px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none", }}
                                                        rows={2}
                                                        cols={112}
                                                        value={SangerSequencingStatus2[index]?.parameter_value}
                                                        onChange={(e) => updateStatus2(SangerSequencingStatus2[index]?.id, e.target.value, index, "free_text", SangerSequencingStatus2[index])}
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload2(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                }
                                else {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "95%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px", marginTop: marginTop }}
                                        >
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload2(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                }
                            })}

                        </>
                    </div>
                    <div style={{ width: "95%", marginLeft: "30px" }}>
                        <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "20px" }}>Important: As per the PRE-NATAL DIAGNOSTIC TECHNIQUES (REGULATIONS & PREVENTION OF MISUSE) AMENDMENT ACT 2002, sex determination shall not be done for all prenatal samples.</p>
                    </div>

                    <div>
                        {/* doctor sign */}
                        <div
                            style={{
                                width: '89%',
                                display: 'flex',
                                padding: 0,
                                margin: 0,
                                justifyContent: 'space-around',
                                marginTop: '30px',
                            }}
                        >
                            {SangerSequencingdoctorList &&
                                SangerSequencingdoctorList?.length > 0 &&
                                SangerSequencingdoctorList?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <img
                                                alt="description of image"
                                                style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                                src={list?.parameter_url}
                                            />
                                        </>
                                    );
                                })}
                        </div>
                        <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                            {SangerSequencingdoctorList &&
                                SangerSequencingdoctorList?.length > 0 &&
                                SangerSequencingdoctorList?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <textarea
                                                style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                                rows={4}
                                                cols={140}
                                                value={list?.parameter_value}
                                                onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                            />
                                        </>
                                    );
                                })}
                        </div>

                        {/* footer section starting */}
                        <div className="SangerSequencing-page-footer">
                            {/* footer area */}
                            <div style={{ padding: '20px' }}>


                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        background: "#fff",
                                    }}
                                >

                                    <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                        <h3>
                                            <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                        </h3>
                                    </div>
                                    <div
                                        style={{
                                            width: "85%",
                                            textAlign: "left",
                                            padding: 10,
                                            marginTop: "-3px",
                                        }}
                                    >
                                        <div
                                            style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                        >
                                            <div style={{ width: "33%", marginLeft: 8 }}>
                                                <img
                                                    src={callIcon}
                                                    alt="logo"
                                                    style={{ width: "20px", margin: "2px" }}
                                                />{" "}
                                                <span style={{ color: "red" }}>
                                                    <b>931-126-1989</b>
                                                </span>
                                            </div>
                                            <div style={{ width: "33%", marginLeft: 8 }}>
                                                <img
                                                    src={maillIcon}
                                                    alt="logo"
                                                    style={{ width: "20px", margin: "2px" }}
                                                />
                                                <span style={{ color: "red" }}>
                                                    <b>genee@redcliffelabs.com</b>
                                                </span>
                                            </div>
                                            <div style={{ width: "33%", marginLeft: "68px" }}>
                                                <img
                                                    src={browserIcon}
                                                    alt="logo"
                                                    style={{ width: "20px", margin: "2px" }}
                                                />
                                                <span style={{ color: "red" }}>
                                                    <b>www.redcliffelabs.com</b>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                margin: "10px 0px",
                                                textAlign: "left",
                                            }}
                                        >
                                            <h5 style={{ marginLeft: "16px" }}>
                                                {" "}
                                                <b>
                                                    Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                    Uttar Pradesh, 201301
                                                </b>
                                            </h5>
                                        </div>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                margin: "10px 0px",
                                                marginLeft: "16px",
                                                textAlign: "left",
                                            }}
                                        >
                                            <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                                {" "}
                                                All Lab are subjected to clinical interpretations by
                                                qualified medical professional and this report is not
                                                subject to use for any medico-legal purpose.
                                            </p>
                                        </div>
                                        <hr
                                            style={{
                                                backgroundColor: "red",
                                                width: "100%",
                                                height: "8px",
                                                marginTop: "10px",
                                            }}
                                            className="SangerSequencing-box"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* footer area closed */}
                        </div>
                                            {
                                                uuid && (
                                                    <div className="hide-section-rating">
                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                    </div>
                                                )
                                            }
                    </div>
                </div >
            </div>
        </Grammarly>
    );
};
const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(SangerSequencingReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}